import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import InfoCard from "../components/Cards/InfoCard";
import LineChart from "../components/Charts/LineChart";
import MyGauge from "../components/Charts/MyGauge";
import Liquidgauge from "../components/Charts/Liquidgauge";
import { FaTemperatureHigh, FaTint, FaLeaf, FaBolt, FaLightbulb, FaWater, FaShower, FaUtensils, FaVideo,
  FaBus,
  FaGasPump,
  FaTachometerAlt,
  FaRoad,
  FaThermometerHalf,
  FaFan,
  FaCouch, FaBed , FaBriefcase, FaUsers, FaWifi, FaCloud
} from "react-icons/fa";
import AlertsList from "../components/Alerts/AlertsList";
import SensorMap from "../components/Map/SensorMap";
import BarChart from "../components/Charts/BarChart";
import FloorPlan from "../components/Charts/FloorPlan";
import VehicleTracker from "../components/Map/VehicleTracker";
import RoomModal from "../components/Modals/RoomModal";
import {
  LineChart as ReLineChart,
  BarChart as ReBarChart,
  Bar,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { useLocation, useNavigate } from "react-router-dom";

const Dashboard = ({ devices, alerts }) => {
  const navigate = useNavigate();
  const iconMap = {
  FaCouch: FaCouch,
  FaBed: FaBed,
  FaUtensils: FaUtensils,
  FaBriefcase: FaBriefcase,
  FaUsers: FaUsers,
  FaWifi: FaWifi,
};

  const { id } = useParams(); // ✅ Device ID from URL
  const deviceId = parseInt(id);

  // ✅ Find selected device
  const device = devices.find((d) => d.id === deviceId);

  // ✅ Filter alerts for this device
  const deviceAlerts = useMemo(() => {
    return alerts.filter((alert) => alert.device_id === deviceId);
  }, [alerts, deviceId]);

  // ✅ Unit preference
  const unitPreference = localStorage.getItem("unit") || "Metric";

  // ✅ Convert device metrics based on unit
  const convertedData = useMemo(() => {
    if (!device) return null;

    let temp = parseFloat(device.temperature);
    let energyVal = parseFloat(device.energy);

    if (unitPreference === "Imperial") {
      temp = (temp * 9) / 5 + 32; // Celsius → Fahrenheit
    }

    return {
      temperature: temp.toFixed(1),
      humidity: parseFloat(device.humidity),
      co2: parseFloat(device.co2),
      energy: energyVal.toFixed(1),
      name: device.name,
      status: device.status,
      lastUpdated: device.lastUpdated,
    };
  }, [device, unitPreference]);

  if (!device || !convertedData) {
    return <p className="text-white">Device not found</p>;
  }

  const tempUnit = unitPreference === "Imperial" ? "°F" : "°C";

  const currentData = {
    temperature: parseFloat(convertedData.temperature),
    humidity: convertedData.humidity,
  };

  console.log(device)
  
  if (device.type === "Industrial Automation") {
    return (
      <div className="text-white">
        <h1 className="text-2xl font-bold mb-6">{device.name} - Industrial Dashboard</h1>

        {/* Current Status & Machine Image */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
            {/* Machine Image & Status */}
            <div className="bg-gray-800 p-4 rounded-xl text-center flex flex-col justify-center">
                <img
                src="/machine.jpg"
                alt="Machine"
                className="w-full rounded mb-4"
                />
                <h3 className="text-lg">Current Status:</h3>
                <p
                className={`text-2xl font-bold ${
                    device.status === "Online" ? "text-green-400" : "text-red-400"
                }`}
                >
                {device.status}
                </p>
            </div>

            {/* Current Pressure Gauge */}
            <MyGauge
                value={device.currentPressure}
                heading="Current Pressure"
                unit="bar"
                maxValue={10} // ✅ Assuming 10 bar max
            />

            {/* Current Temp Gauge */}
            <MyGauge
                value={device.currentTemp}
                heading="Current Temperature"
                unit="°C"
                maxValue={100} // ✅ Assuming 100°C max
            />
        </div>

        {/* Broken Events Table */}
        <div className="bg-gray-800 p-4 rounded-xl mb-6">
          <h3 className="text-lg font-bold mb-4">Last Broken Events</h3>
          <table className="w-full text-left">
            <thead>
              <tr>
                <th className="p-2">Event</th>
                <th className="p-2">Month</th>
                <th className="p-2">Date & Time</th>
              </tr>
            </thead>
            <tbody>
              {device.brokenEvents?.map((event, idx) => (
                <tr key={idx}>
                  <td className="p-2">{event.event}</td>
                  <td className="p-2">{event.month}</td>
                  <td className="p-2">{event.datetime}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Charts */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Monthly Availability Chart */}
        <BarChart
            title="Monthly Availability (hours)"
            data={[
            {
                month: "July",
                working: device.monthlyAvailability?.working || 0,
                idle: device.monthlyAvailability?.idle || 0,
                stopped: device.monthlyAvailability?.stopped || 0,
            },
            {
                month: "August",
                working: Math.floor(200 + Math.random() * 100),
                idle: Math.floor(50 + Math.random() * 50),
                stopped: Math.floor(50 + Math.random() * 50),
            },
            {
                month: "September",
                working: Math.floor(200 + Math.random() * 100),
                idle: Math.floor(50 + Math.random() * 50),
                stopped: Math.floor(50 + Math.random() * 50),
            },
            {
                month: "October",
                working: Math.floor(200 + Math.random() * 100),
                idle: Math.floor(50 + Math.random() * 50),
                stopped: Math.floor(50 + Math.random() * 50),
            },
            {
                month: "November",
                working: Math.floor(200 + Math.random() * 100),
                idle: Math.floor(50 + Math.random() * 50),
                stopped: Math.floor(50 + Math.random() * 50),
            },
            ]}
            bars={[
            { key: "working", color: "#22c55e", label: "Working" },
            { key: "idle", color: "#facc15", label: "Idle" },
            { key: "stopped", color: "#ef4444", label: "Stopped" },
            ]}
        />

        {/* Monthly Production Chart */}
        <BarChart
            title="Monthly Manufactured Pieces (qty)"
            data={[
            { month: "July", produced: device.monthlyProduction?.july || 0, recommended: 1000 },
            { month: "August", produced: device.monthlyProduction?.august || 0, recommended: 1000 },
            { month: "September", produced: device.monthlyProduction?.september || 0, recommended: 1000 },
            { month: "October", produced: device.monthlyProduction?.october || 0, recommended: 1000 },
            { month: "November", produced: device.monthlyProduction?.november || 0, recommended: 1000 },
            ]}
            bars={[
            { key: "produced", color: "#60a5fa", label: "Produced" },
            { key: "recommended", color: "#84cc16", label: "Recommended" },
            ]}
        />
        </div>

      </div>
    );
  }

  if (device.type === "Smart Agriculture") {
  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">{device.name} - Smart Agriculture</h1>

      {/* Summary */}
      <div className="bg-gray-800 p-4 rounded-xl mb-6 text-gray-200 flex flex-col sm:flex-row sm:justify-between">
        <span>
          Status:{" "}
          <span className={`ml-2 font-bold ${device.status === "Online" ? "text-green-400" : "text-red-400"}`}>
            {device.status}
          </span>
        </span>
        <span className="mt-2 sm:mt-0">Last Updated: {device.lastUpdated}</span>
      </div>

      {/* Top Widgets */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
        <div className="bg-gray-800 p-4 rounded-xl text-center">
            <h3 className="text-lg mb-2">Water Level</h3>
          {/* <MyGauge value={device.waterLevel} heading="Water Tank" unit="%" maxValue={100} /> */}
          <Liquidgauge
            value={device.waterLevel}
            radius={120}
          />
        </div>
        <div className="bg-gray-800 p-4 rounded-xl text-center">
          <MyGauge value={device.temperature} heading="Temperature" unit="°C" maxValue={300} />
        </div>
        <div className="bg-gray-800 p-4 rounded-xl text-center">
          <MyGauge value={device.humidity} heading="Humidity" unit="%" maxValue={100} />
        </div>
      </div>

      {/* Charts */}
      <div className="bg-gray-800 p-4 rounded-xl mb-6">
        <LineChart data={{ temperature: parseFloat(device.temperature), humidity: parseFloat(device.humidity) }} />
      </div>

      {/* Irrigation Controls */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-gray-800 p-4 rounded-xl text-center">
          <h3 className="text-lg mb-2">Drip Irrigation System</h3>
          <p className="text-2xl font-bold">{device.irrigationSystem}</p>
        </div>
        <div className="bg-gray-800 p-4 rounded-xl text-center">
          <h3 className="text-lg mb-2">Sprinkler Status</h3>
          <p className="text-2xl font-bold">{device.sprinklerStatus}</p>
        </div>
      </div>
    </div>
  );
}

if (device.type === "Building Monitoring") {
  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">{device.name} Dashboard</h1>

      {/* Summary */}
      <div className="bg-gray-800 p-4 rounded-xl mb-6 text-gray-200 flex flex-col sm:flex-row sm:justify-between">
        <span>
          Status:{" "}
          <span className={`ml-2 font-bold ${device.status === "Online" ? "text-green-400" : "text-red-400"}`}>
            {device.status}
          </span>
        </span>
        <span className="mt-2 sm:mt-0">Last Updated: {device.lastUpdated}</span>
      </div>

      {/* Top Row: Doors & Alarm */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
        <div className="bg-gray-800 p-4 rounded-xl text-center">
          <h3>Entrance Door</h3>
          <p className="text-xl">{device.entranceDoor}</p>
        </div>
        <div className="bg-gray-800 p-4 rounded-xl text-center">
          <h3>Back Door</h3>
          <p className="text-xl">{device.backDoor}</p>
        </div>
        <div className="bg-gray-800 p-4 rounded-xl text-center">
          <h3>Alarm</h3>
          <p className={`text-xl font-bold ${device.alarmStatus === "Armed" ? "text-blue-400" : "text-yellow-400"}`}>
            {device.alarmStatus}
          </p>
        </div>
        <div className="bg-gray-800 p-4 rounded-xl text-center">
          <h3>Energy</h3>
          <p className="text-2xl">{device.energyConsumed} kWh</p>
        </div>
      </div>

      {/* Next Row: Gauges */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
        <MyGauge value={device.livingRoomTemp} heading="Living Room Temp" unit="°C" maxValue={100} />
        <MyGauge value={device.livingRoomHumidity} heading="Humidity" unit="%" maxValue={100} />
        <MyGauge value={device.co2Level} heading="CO₂" unit="ppm" maxValue={2000} />
      </div>

      {/* Lights & Leak Status */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        {/* Lights Section */}
        <div className="bg-gray-800 p-4 rounded-xl">
          <h3 className="mb-4 text-lg font-bold flex items-center gap-2">
            <FaLightbulb className="text-yellow-400" /> Lights Status
          </h3>
          <div className="space-y-3">
            {[
              { label: "Office", value: device.lights.office },
              { label: "Living Room", value: device.lights.livingRoom },
              { label: "Bedroom", value: device.lights.bedroom },
            ].map((light, index) => (
              <div
                key={index}
                className="flex justify-between items-center border-b border-gray-700 pb-2"
              >
                <span>{light.label}</span>
                <span
                  className={`px-3 py-1 rounded-full text-sm font-semibold ${
                    light.value === "ON"
                      ? "bg-green-500 text-white"
                      : "bg-gray-600 text-gray-200"
                  }`}
                >
                  {light.value}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Leak Detection Section */}
        <div className="bg-gray-800 p-4 rounded-xl">
          <h3 className="mb-4 text-lg font-bold flex items-center gap-2">
            <FaWater className="text-blue-400" /> Leak Detection
          </h3>
          <div className="space-y-3">
            {[
              { icon: <FaShower />, label: "Sink", value: device.leakStatus.sink },
              {
                icon: <FaShower />,
                label: "Bathroom",
                value: device.leakStatus.bathroom,
              },
              {
                icon: <FaUtensils />,
                label: "Dishwasher",
                value: device.leakStatus.dishwasher,
              },
            ].map((leak, index) => (
              <div
                key={index}
                className="flex justify-between items-center border-b border-gray-700 pb-2"
              >
                <span className="flex items-center gap-2">
                  {leak.icon} {leak.label}
                </span>
                <span
                  className={`px-3 py-1 rounded-full text-sm font-semibold ${
                    leak.value === "Leaking"
                      ? "bg-red-500 text-white"
                      : "bg-green-500 text-white"
                  }`}
                >
                  {leak.value}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
          
      {/* Camera Section */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {/* Entrance Camera */}
      <div className="bg-gray-800 p-4 rounded-xl">
        <h3 className="mb-4 text-lg font-bold flex items-center gap-2">
          <FaVideo className="text-green-400" /> Entrance Camera
        </h3>
        <video
          src="/videos/entrance.mp4" // ✅ Replace with your video path
          autoPlay
          loop
          muted
          className="w-full rounded-xl border border-gray-700"
        ></video>
      </div>

      {/* Corridor Camera */}
      <div className="bg-gray-800 p-4 rounded-xl">
        <h3 className="mb-4 text-lg font-bold flex items-center gap-2">
          <FaVideo className="text-green-400" /> Corridor Camera
        </h3>
        <video
          src="/videos/corridor.mp4" // ✅ Replace with your video path
          autoPlay
          loop
          muted
          className="w-full rounded-xl border border-gray-700"
        ></video>
      </div>
    </div>


    </div>
  );
}
if (device.type === "Freezer Status") {
  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">{device.name} Dashboard</h1>

      {/* Summary */}
      <div className="bg-gray-800 p-4 rounded-xl mb-6 text-gray-200 flex flex-col sm:flex-row sm:justify-between">
        <span>
          Status:{" "}
          <span className={`ml-2 font-bold ${device.status === "Online" ? "text-green-400" : "text-red-400"}`}>
            {device.status}
          </span>
        </span>
        <span className="mt-2 sm:mt-0">Last Updated: {device.lastUpdated}</span>
      </div>

    {/* Main Grid */}
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
      {/* Temperature Card */}
      <div className="bg-gray-800 p-6 rounded-xl text-center flex flex-col justify-center">
        <h3 className="text-lg mb-2">Temperature</h3>
        <p className="text-4xl font-bold">{device.freezerTemperature || "--"} °F</p>
        <p className="text-sm text-gray-400">Ice Cream</p>
      </div>

      {/* Compressor Status */}
      <div className="bg-gray-800 p-6 rounded-xl text-center">
        <h3 className="text-lg mb-2">Compressor Status</h3>
        <p className={`text-2xl font-bold ${device.compressorStatus === "on" ? "text-green-400" : "text-red-400"}`}>
          {device.compressorStatus}
        </p>
      </div>

      {/* Door Status */}
      <div className="bg-gray-800 p-6 rounded-xl text-center">
        <h3 className="text-lg mb-2">Door Status</h3>
        <p className={`text-2xl font-bold ${device.doorStatus === "open" ? "text-yellow-400" : "text-blue-400"}`}>
          {device.doorStatus}
        </p>
      </div>
    </div>

    {/* Temperature History Chart */}
    <div className="bg-gray-800 p-4 rounded-xl mb-6">
      <h3 className="mb-4 text-lg font-bold">Temperature History</h3>
      {/* Use Recharts Line Chart */}
      <ResponsiveContainer width="100%" height={300}>
        <ReLineChart
          data={device.temperatureHistory.map((t, i) => ({ time: t.time, temp: parseFloat(t.temp) }))}
        >
          <XAxis dataKey="time" />
          <YAxis />
          <Tooltip />
          <Line type="monotone" dataKey="temp" stroke="#00d8ff" />
        </ReLineChart>
      </ResponsiveContainer>
    </div>

    {/* Historical Data Table */}
    <div className="bg-gray-800 p-4 rounded-xl">
      <h3 className="mb-4 text-lg font-bold">Historical Data</h3>
      <table className="w-full text-left text-white">
        <thead>
          <tr>
            <th className="p-2">Compressor</th>
            <th className="p-2">Door</th>
            <th className="p-2">Temperature</th>
            <th className="p-2">Date & Time</th>
          </tr>
        </thead>
        <tbody>
          {device.historicalData.map((row, index) => (
            <tr key={index} className="border-t border-gray-700">
              <td className="p-2">{row.compressor}</td>
              <td className="p-2">{row.door}</td>
              <td className="p-2">{row.temperature}</td>
              <td className="p-2">{row.datetime}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
  )
}

if (device.type === "Energy Metering") {
  return (
<div>
    <h2 className="text-2xl font-bold mb-6">{device.name} - Energy Metering Dashboard</h2>

    {/* Gauges Section */}
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-6">
      <MyGauge value={device.current} heading="Current" unit="A" max={2} />
      <MyGauge value={device.load} heading="Load" unit="%" max={100} />
      <MyGauge value={device.voltage} heading="Voltage" unit="V" max={300} />
      <div className="bg-gray-800 p-4 rounded-xl flex flex-col items-center justify-center">
        <h3 className="text-lg font-bold">Relay Status</h3>
        <p className="text-2xl font-bold mt-2">{device.relayStatus}</p>
      </div>
    </div>

    {/* Line Charts */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
      <div className="bg-gray-800 p-4 rounded-xl">
        <h3 className="text-lg mb-4 font-bold">Current Energy Spent</h3>
        <ResponsiveContainer width="100%" height={250}>
          <ReLineChart data={device.energyHistory}>
            <XAxis dataKey="time" />
            <YAxis />
            <Tooltip />
            <Line type="monotone" dataKey="energy" stroke="#f87171" name="Energy (kWh)" />
          </ReLineChart>
        </ResponsiveContainer>
      </div>

      <div className="bg-gray-800 p-4 rounded-xl">
        <h3 className="text-lg mb-4 font-bold">Current Power Consumed</h3>
        <ResponsiveContainer width="100%" height={250}>
          <ReLineChart data={device.powerHistory}>
            <XAxis dataKey="time" />
            <YAxis />
            <Tooltip />
            <Line type="monotone" dataKey="power" stroke="#60a5fa" name="Power (W)" />
          </ReLineChart>
        </ResponsiveContainer>
      </div>
    </div>

    {/* Logs Table */}
    <div className="bg-gray-800 p-4 rounded-xl">
      <h3 className="text-lg mb-4 font-bold">Logs</h3>
      <table className="w-full text-left text-white">
        <thead>
          <tr>
            <th className="py-2">Load</th>
            <th className="py-2">Voltage</th>
            <th className="py-2">Current</th>
            <th className="py-2">Date & Time</th>
          </tr>
        </thead>
        <tbody>
          {device.logs.map((log, index) => (
            <tr key={index} className="border-t border-gray-600">
              <td className="py-2">{log.load}</td>
              <td className="py-2">{log.voltage}</td>
              <td className="py-2">{log.current}</td>
              <td className="py-2">{log.datetime}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
  )}

  if (device.type === "Water Metering") {
  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">{device.name} Dashboard</h1>

      {/* Top Row Metrics */}
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-6 mb-6">
        <InfoCard title="Consumed - Day" value={device.consumedDay} unit="m³" />
        <InfoCard title="Consumed - Week" value={device.consumedWeek} unit="m³" />
        <InfoCard title="Consumed - All Time" value={device.consumedAllTime} unit="m³" />
        <MyGauge value={device.flow} heading="Flow" unit="m³/hr" max={5} />
        <MyGauge value={device.velocity} heading="Velocity" unit="m/s" max={2} />
        <MyGauge value={device.batteryLevel} heading="Battery" unit="%" max={100} />
      </div>

      {/* Charts Section */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Daily Consumption */}
        <div className="bg-gray-800 p-4 rounded-xl">
          <h3 className="mb-2 font-bold">Daily Consumption</h3>
          <ResponsiveContainer width="100%" height={250}>
            <ReBarChart data={device.dailyConsumption.map((value, i) => ({ name: i + 1, value }))}>
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="value" fill="#00bfff" />
            </ReBarChart>
          </ResponsiveContainer>
        </div>

        {/* Flow History */}
        <div className="bg-gray-800 p-4 rounded-xl">
          <h3 className="mb-2 font-bold">Flow</h3>
          <ResponsiveContainer width="100%" height={250}>
            <ReLineChart data={device.flowHistory}>
              <XAxis dataKey="time" />
              <YAxis />
              <Tooltip />
              <Line type="monotone" dataKey="value" stroke="#00ffcc" />
            </ReLineChart>
          </ResponsiveContainer>
        </div>

        {/* Velocity History */}
        <div className="bg-gray-800 p-4 rounded-xl">
          <h3 className="mb-2 font-bold">Velocity</h3>
          <ResponsiveContainer width="100%" height={250}>
            <ReLineChart data={device.velocityHistory}>
              <XAxis dataKey="time" />
              <YAxis />
              <Tooltip />
              <Line type="monotone" dataKey="value" stroke="#ffaa00" />
            </ReLineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
if (device.type === "Vehicle Tracking") {
  return (
    <div>
      {/* Summary */}
      <div className="bg-gray-800 p-4 rounded-xl mb-6 text-gray-200 flex flex-col sm:flex-row sm:justify-between">
        <span>
          Status:{" "}
          <span className={`ml-2 font-bold ${device.status === "Online" ? "text-green-400" : "text-red-400"}`}>
            {device.status}
          </span>
        </span>
        <span className="mt-2 sm:mt-0">Last Updated: {device.lastUpdated}</span>
      </div>


      {/* Map + Vehicle Info */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
        {/* Map */}
        <div className="lg:col-span-2 bg-gray-800 p-4 rounded-xl">
          <h3 className="text-lg font-bold mb-2">Vehicle Route</h3>
          <VehicleTracker route={device.route} />
        </div>

        {/* Vehicle Info */}
        <div className="bg-gray-800 p-6 rounded-xl shadow-lg">
  <h3 className="text-xl font-bold mb-4 flex items-center gap-2">
    <FaBus className="text-blue-400" /> Vehicle Status
  </h3>

  <div className="space-y-3 text-gray-300">
    <div className="flex justify-between items-center border-b border-gray-700 pb-2">
      <span className="flex items-center gap-2">
        <FaGasPump className="text-green-400" /> Fuel Level
      </span>
      <span className="font-semibold">{device.fuelLevel}%</span>
    </div>

    <div className="flex justify-between items-center border-b border-gray-700 pb-2">
      <span className="flex items-center gap-2">
        <FaTachometerAlt className="text-yellow-400" /> Speed
      </span>
      <span className="font-semibold">{device.busSpeed} MPH</span>
    </div>

    <div className="flex justify-between items-center border-b border-gray-700 pb-2">
      <span className="flex items-center gap-2">
        <FaRoad className="text-purple-400" /> Trip Odometer
      </span>
      <span className="font-semibold">{device.tripOdometer} miles</span>
    </div>

    <div className="flex justify-between items-center border-b border-gray-700 pb-2">
      <span className="flex items-center gap-2">
        <FaThermometerHalf className="text-red-400" /> Internal Temp
      </span>
      <span className="font-semibold">{device.internalTemp} °F</span>
    </div>

    <div className="flex justify-between items-center">
      <span className="flex items-center gap-2">
        <FaFan className="text-blue-400" /> AC Status
      </span>
      <span
        className={`font-semibold ${
          device.acStatus === "ON" ? "text-green-400" : "text-red-400"
        }`}
      >
        {device.acStatus}
      </span>
    </div>
  </div>
</div>

      </div>

      {/* Speed Chart */}
      <div className="bg-gray-800 p-4 rounded-xl">
        <h3 className="text-lg font-bold mb-2">Speed History</h3>
        <ResponsiveContainer width="100%" height={300}>
          <ReLineChart data={device.speedHistory}>
            <XAxis dataKey="time" />
            <YAxis />
            <Tooltip />
            <Line type="monotone" dataKey="speed" stroke="#00d8ff" />
          </ReLineChart>
        </ResponsiveContainer>
      </div>
    </div>
  )
}

if (device.type === "Smart Home Dashboard") {
  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Smart Home Dashboard</h1>

      {/* Status */}
      <div className="bg-gray-800 p-4 rounded-xl mb-6 text-gray-200 flex flex-col sm:flex-row sm:justify-between">
        <span>
          Status:{" "}
          <span className={`ml-2 font-bold ${device.status === "Online" ? "text-green-400" : "text-red-400"}`}>
            {device.status}
          </span>
        </span>
        <span className="mt-2 sm:mt-0">Last Updated: {device.lastUpdated}</span>
      </div>

      {/* Weather & Air Quality */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
        <div className="bg-gray-800 p-4 rounded-xl text-center">
          <h3 className="text-lg font-bold mb-2">Weather</h3>
          <div className="text-5xl">{device.weather.icon}</div>
          <p className="text-3xl">{device.weather.temperature}°F</p>
          <p>{device.weather.condition}</p>
          <p>High {device.weather.high}° | Low {device.weather.low}°</p>
        </div>
        <div className="bg-gray-800 p-4 rounded-xl text-center">
          <h3 className="text-lg font-bold mb-2">Air Quality</h3>
          <div className="text-5xl mb-4">{device.airQuality.icon}</div>
          <p className="text-4xl">{device.airQuality.aqi}</p>
          <p>{device.airQuality.status}</p>
        </div>
      </div>

      {/* Hub with RSSI */}
      <div className="bg-gray-800 p-4 rounded-xl mb-6 text-center">
        <h3 className="text-lg font-bold mb-2">Hub Connection</h3>
        <p className="text-2xl">{device.hub.connected ? "Connected ✅" : "Disconnected ❌"}</p>
        <p>Signal Strength: {device.hub.rssi} dBm</p>
      </div>

      {/* Rooms Grid */}
    <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-6">
  {device.floorPlanDevices.map((roomData) => {
    const Icon = iconMap[roomData.icon];
    return (
      <div
        key={roomData.room}
        onClick={() => {
          if (roomData.room === "Hall") {
            window.open("http://192.168.0.1/", "_blank"); // ✅ Open in new tab
          } else {
            navigate(`/room/${roomData.room}`, { state: roomData }); // ✅ Navigate as before
          }
        }}
        className="bg-gray-800 p-6 rounded-xl text-center cursor-pointer hover:bg-gray-700 transition flex flex-col items-center justify-center"
      >
        <Icon className="text-blue-400 text-4xl mb-2" />
        <h3 className="text-lg font-bold">{roomData.room}</h3>
      </div>
    );
  })}
</div>



      {/* Recent Activity */}
      <div className="bg-gray-800 p-4 rounded-xl mb-6">
        <h3 className="text-lg font-bold mb-2">Recent Activity</h3>
        <ul>
          {device.recentActivity.map((a, i) => (
            <li key={i} className="text-sm">{a.time} - {a.message}</li>
          ))}
        </ul>
      </div>

      {/* Energy Monitor */}
      <div className="bg-gray-800 p-4 rounded-xl mb-6">
        <h3 className="text-lg font-bold mb-2">Energy Monitor</h3>
        <ResponsiveContainer width="100%" height={200}>
          <ReLineChart data={device.energyMonitor}>
            <XAxis dataKey="month" />
            <YAxis />
            <Tooltip formatter={(value, name) => {
              if (name === "electricity") return [`${value} kWh`, "Electricity"];
              if (name === "gas") return [`${value} m³`, "Gas"];
              if (name === "water") return [`${value} L`, "Water"];
              return value;
            }} />
            <Line type="monotone" dataKey="electricity" stroke="#00d8ff" name="Electricity (kWh)" />
            <Line type="monotone" dataKey="gas" stroke="#f39c12" name="Gas (m³)" />
            <Line type="monotone" dataKey="water" stroke="#3498db" name="Water (L)" />
          </ReLineChart>
        </ResponsiveContainer>
      </div>

      {/* Floor Plan */}
      <FloorPlan devices={device.floorPlanDevices} />
    </div>
  );
}

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">
        {convertedData.name} Dashboard
      </h1>

      {/* Device Summary */}
      <div className="bg-gray-800 p-4 rounded-xl mb-6 text-gray-200 flex flex-col sm:flex-row sm:justify-between">
        <span>
          Status:{" "}
          <span
            className={`ml-2 font-bold ${
              convertedData.status === "Online" ? "text-green-400" : "text-red-400"
            }`}
          >
            {convertedData.status}
          </span>
        </span>
        <span className="mt-2 sm:mt-0">Last Updated: {convertedData.lastUpdated}</span>
      </div>

      {/* Info Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
        <InfoCard title="Temperature" value={convertedData.temperature} unit={tempUnit} icon={<FaTemperatureHigh />} color="text-red-400" />
        <InfoCard title="Humidity" value={convertedData.humidity} unit="%" icon={<FaTint />} color="text-blue-400" />
        <InfoCard title="CO₂" value={convertedData.co2} unit="ppm" icon={<FaLeaf />} color="text-green-400" />
        <InfoCard title="Energy" value={convertedData.energy} unit="kWh" icon={<FaBolt />} color="text-yellow-400" />
      </div>

      {/* Charts, Alerts, and Map */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Left Column */}
        <div className="lg:col-span-2 flex flex-col gap-6">
          <LineChart data={currentData} />
          <SensorMap deviceId={deviceId} devices={devices} />
        </div>

        {/* Right Column */}
        <div className="flex flex-col gap-6">
          {/* Energy Gauge */}
            <MyGauge
            value={convertedData.energy}
            heading="Energy Usage"
            unit="kW"
            maxValue={5} // ✅ Based on (3 + Math.random() * 2)
            />
          <AlertsList alerts={deviceAlerts} />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
